/* * 本页面为车辆新增和车辆修改界面 * 通过pageType字段来区分：1新增，2修改 * */
<template>
  <div ref="pageView" class="page-view container-view">
    <!-- title -->
    <section class="title-section fixed-view">
      <e6-title>
        {{ pageTitle }}
        <template slot="breadcrumb">
          <e6-breadcrumb :breadcrumbs="breadcrumbs"></e6-breadcrumb>
        </template>
      </e6-title>
    </section>
    <!-- title end -->
    <!-- content -->
    <section
      class="content-section"
      :style="{ height: resizeViewHeight + 'px' }"
    >
      <div class="form-wrapper">
        <e6-form-extend
          class="e6-from--column-2"
          ref="formExtend"
          :formExtend="formExtend"
          :inline="true"
          label-width="200px"
          :submitLoadingState="loadingState"
          @submitForm="handleSubmitForm"
          @resetForm="handleResetForm"
        >
          <template slot-scope="slotForms">
            <el-form-item
              label="车牌号"
              prop="forms.vehicleNum"
              :rules="[
                {
                  required: true,
                  message: '请输入',
                  trigger: 'blur'
                },
                { trigger: 'blur' }
              ]"
            >
              <el-input
                v-model="slotForms.forms.vehicleNum"
                placeholder="车牌名称"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item
              prop="forms.comparyId"
              label="所属企业"
              :rules="[
                {
                  required: true,
                  message: '请选择所属企业',
                  trigger: 'change'
                }
              ]"
            >
              <el-select
                v-model="slotForms.forms.comparyId"
                collapse-tags
                filterable
                value-key="dicId"
                placeholder="所属企业"
              >
                <el-option
                  v-for="item in allCustomer"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="联系人" prop="forms.contactMan">
              <el-input
                v-model="slotForms.forms.contactMan"
                placeholder="联系人"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item
              label="联系电话"
              prop="forms.contactPhone"
              :rules="[{ validator: CheckPhone, trigger: 'blur' }]"
            >
              <el-input
                v-model="slotForms.forms.contactPhone"
                placeholder="联系电话"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item prop="forms.vehicleColor" label="车牌颜色">
              <dict-select
                v-model="slotForms.forms.vehicleColor"
                placeholder="车牌颜色"
                :pkey="'vehicle_color'"
              ></dict-select>
            </el-form-item>
            <el-form-item prop="forms.vehicleBrand" label="制冷机品牌">
              <el-input
                v-model="slotForms.forms.vehicleBrand"
                placeholder="制冷机品牌"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="定位设备唯一识别码">
              <el-input
                v-model="slotForms.forms.terUuid"
                placeholder="定位设备唯一识别码"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="载重设备唯一识别码">
              <el-input
                v-model="slotForms.forms.loadUuid"
                placeholder="载重设备唯一识别码"
                clearable
              ></el-input>
            </el-form-item>

            <el-form-item prop="forms.refrigerateType" label="制冷方式">
              <dict-select
                v-model="slotForms.forms.refrigerateType"
                placeholder="请选择制冷方式"
                :pkey="'refrigerate_type'"
              ></dict-select>
            </el-form-item>
            <el-form-item prop="forms.powerType" label="供电方式">
              <dict-select
                v-model="slotForms.forms.powerType"
                placeholder="请选择供电方式"
                :pkey="'power_type'"
              ></dict-select>
            </el-form-item>
            <el-form-item prop="forms.carriageType" label="冷藏车厢类型">
              <dict-select
                v-model="slotForms.forms.carriageType"
                placeholder="请选择"
                :pkey="'carriage_type'"
              ></dict-select>
            </el-form-item>
            <el-form-item prop="forms.temperatureLow" label="车厢平均标准温度">
              <el-input
                style="width: 140px"
                v-model="slotForms.forms.temperatureLow"
                placeholder="请输入"
                clearable
              ></el-input
              >℃-
              <el-input
                style="width: 140px"
                v-model="slotForms.forms.temperatureHigh"
                placeholder="请输入"
                clearable
              ></el-input
              >℃
            </el-form-item>
            <el-form-item label="冷藏配送证号" prop="forms.coldPassportNo">
              <el-input
                v-model="slotForms.forms.coldPassportNo"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="进口食品专用证编号" prop="forms.importFoodNo">
              <el-input
                v-model="slotForms.forms.importFoodNo"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item prop="forms.vehicleType" label="车辆类型">
              <dict-select
                v-model="slotForms.forms.vehicleType"
                placeholder="请选择车辆类型"
                :pkey="'vehicle_type'"
              ></dict-select>
            </el-form-item>
            <el-form-item prop="forms.transType" label="运输类型">
              <!-- <dict-select
                v-model="slotForms.forms.transType"
                placeholder="请选择运输类型"
                :pkey="'trans_type'"
                :multiple="true"
              ></dict-select> -->
              <el-select
                v-model="slotForms.forms.transType"
                filterable
                clearable=""
                :multiple="true"
                placeholder="请选择"
                @change="changeTransType"
              >
                <el-option
                  v-for="item in transtypeList"
                  :key="item.dicId"
                  :label="item.dicName"
                  :value="item.dicId"
                  :disabled="item.disabled"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item
              prop="forms.constantTemperatureType"
              label="制冷制热方式"
            >
              <dict-select
                v-model="slotForms.forms.constantTemperatureType"
                placeholder="请选择恒温车制冷制热方式"
                :pkey="'refrigerate_type'"
              ></dict-select>
            </el-form-item> -->
            <el-form-item label="车辆型号" prop="forms.vehicleModel">
              <el-input
                v-model="slotForms.forms.vehicleModel"
                placeholder="车辆型号"
                clearable
              ></el-input>
            </el-form-item>
            <br />
            <!-- <el-form-item label="车架号" prop="forms.frameNo">
              <el-input
                v-model="slotForms.forms.frameNo"
                placeholder="车架号"
                clearable
              ></el-input>
            </el-form-item> -->
            <el-form-item
              label="车厢厢体(mm)"
              prop="forms.vehicleLen"
              :rules="[
                { validator: validatorIntNum, trigger: 'blur' },
                { validator: CheckNumberLength, trigger: 'blur' }
              ]"
            >
              <el-input
                style="width: 90px"
                v-model="slotForms.forms.vehicleLen"
                placeholder="长"
                clearable
              ></el-input>
              X
              <el-input
                style="width: 90px"
                v-model="slotForms.forms.vehicleWide"
                placeholder="宽"
                clearable
              ></el-input>
              X
              <el-input
                style="width: 90px"
                v-model="slotForms.forms.vehicleHigh"
                placeholder="高"
                clearable
              ></el-input>
            </el-form-item>
            <!-- <el-form-item
              label="厢体离地面高度(M)"
              prop="forms.groundHeight"
              :rules="[
                {
                  pattern: /^\d+(\.\d{1,3})?$/,
                  message: '厢体离地面高度不符合规范(非负数最多三位小数)',
                  trigger: ['blur'],
                },
              ]"
            >
              <el-input
                v-model="slotForms.forms.groundHeight"
                placeholder="厢体离地面高度(M)"
                clearable
              ></el-input>
            </el-form-item> -->

            <el-form-item label="生产厂家" prop="forms.factory">
              <el-input
                v-model="slotForms.forms.factory"
                placeholder="生产厂家"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item
              label="空车质量（kg）"
              prop="forms.tonnage"
              :rules="[
                {
                  pattern: /^\d+(\.\d{1,3})?$/,
                  message: '空车质量（kg）不符合规范(非负数最多三位小数)',
                  trigger: ['blur']
                }
              ]"
            >
              <el-input
                v-model="slotForms.forms.tonnage"
                placeholder="空车质量（kg）"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item
              label="额定载重（kg）"
              prop="forms.ratedLoad"
              :rules="[
                {
                  pattern: /^\d+(\.\d{1,3})?$/,
                  message: '额定载重（kg）不符合规范(非负数最多三位小数)',
                  trigger: ['blur']
                }
              ]"
            >
              <el-input
                v-model="slotForms.forms.ratedLoad"
                placeholder="额定载重（kg）"
                clearable
              ></el-input>
            </el-form-item>
            <!-- <el-form-item
              label="排量(L)"
              prop="forms.outputVolume"
              :rules="[
                {
                  pattern: /^\d+(\.\d{1,3})?$/,
                  message: '排量(L)不符合规范(非负数最多三位小数)',
                  trigger: ['blur'],
                },
              ]"
            >
              <el-input
                v-model="slotForms.forms.outputVolume"
                placeholder="排量(L)"
                clearable
              ></el-input>
            </el-form-item> -->
            <el-form-item label="车辆工作时间" prop="delivery">
              <el-time-picker
                style="width: 300px"
                size="mini"
                is-range
                value-format="HH:mm:ss"
                arrow-control
                v-model="delivery"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                placeholder="选择时间范围"
              >
              </el-time-picker>
            </el-form-item>
            <el-form-item label="车辆出厂日期" prop="productionDate">
              <el-date-picker
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                v-model="slotForms.forms.productionDate"
                type="date"
                placeholder="选择日期"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="车辆使用时长" prop="forms.applyTime">
              <el-input
                :disabled="true"
                v-model="slotForms.forms.applyTime"
                placeholder="车辆使用时长"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="监控设备商" prop="forms.monitorDeviceMerchant">
              <el-input
                v-model="slotForms.forms.monitorDeviceMerchant"
                placeholder="监控设备商"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="载重设备商" prop="forms.loadDeviceMerchant">
              <el-input
                v-model="slotForms.forms.loadDeviceMerchant"
                placeholder="载重设备商"
                clearable
              ></el-input>
            </el-form-item>
            <!--<el-form-item-->
            <!--prop="forms.provinceId"-->
            <!--label="所属省"-->
            <!--:rules="[-->
            <!--{-->
            <!--required: true,-->
            <!--message: '请选择所属省',-->
            <!--trigger: 'change'-->
            <!--}-->
            <!--]"-->
            <!--&gt;-->
            <!--<el-select-->
            <!--v-model="slotForms.forms.provinceId"-->
            <!--placeholder="所属省"-->
            <!--@change="provinceChange"-->
            <!--clearable-->
            <!--filterable-->
            <!--&gt;-->
            <!--<el-option-->
            <!--v-for="item in provinceList"-->
            <!--:key="item.id"-->
            <!--:label="item.name"-->
            <!--:value="item.id"-->
            <!--&gt;</el-option>-->
            <!--</el-select>-->
            <!--</el-form-item>-->

            <!--<el-form-item-->
            <!--prop="forms.regionName"-->
            <!--label="所属市"-->
            <!--:rules="[-->
            <!--{-->
            <!--required: true,-->
            <!--message: '请选择所属市',-->
            <!--trigger: 'change'-->
            <!--}-->
            <!--]"-->
            <!--&gt;-->
            <!--<el-select-->
            <!--v-model="slotForms.forms.regionName"-->
            <!--placeholder="所属市"-->
            <!--clearable-->
            <!--filterable-->
            <!--&gt;-->
            <!--<el-option-->
            <!--v-for="item in cityList"-->
            <!--:key="item.id"-->
            <!--:label="item.name"-->
            <!--:value="item.name"-->
            <!--&gt;</el-option>-->
            <!--</el-select>-->
            <!--</el-form-item>-->
            <hr class="line" />
            <div class="tips">
              若车辆需申请城市冷链配送证，请填写以下内容，均为必填项
            </div>
            <el-form-item
              label="已行驶里程(KM)"
              prop="forms.runMileage"
              :rules="[
                {
                  pattern: /^\d+(\.\d{1,2})?$/,
                  message: '最多两位小数',
                  trigger: ['blur']
                }
              ]"
            >
              <el-input
                v-model="slotForms.forms.runMileage"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="报废时间" prop="forms.scrapDate">
              <el-date-picker
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                v-model="slotForms.forms.scrapDate"
                type="date"
                placeholder="请选择"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="曾获城配证时间" prop="forms.lastGetProof">
              <el-input
                v-model="slotForms.forms.lastGetProof"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="接入省冷链平台时间" prop="forms.createdTime">
              <el-input
                v-if="
                  slotForms.forms.joinDate == '' ||
                    slotForms.forms.joinDate == '1970-01-01 08:00:00'
                "
                v-model="slotForms.forms.createdTime"
                placeholder="请输入"
                :disabled="true"
                clearable
              ></el-input>
              <el-input
                v-else
                v-model="slotForms.forms.joinDate"
                placeholder="请输入"
                :disabled="true"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item
              label="有效期开始时间"
              prop="forms.validDate"
              :rules="[{ validator: startTimeValidator, trigger: 'change' }]"
            >
              <el-date-picker
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                v-model="slotForms.forms.validDate"
                type="date"
                placeholder="选择日期"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item
              label="有效期结束时间"
              prop="forms.notValidDate"
              :rules="[{ validator: endTimeValidator, trigger: 'change' }]"
            >
              <el-date-picker
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                v-model="slotForms.forms.notValidDate"
                type="date"
                placeholder="选择日期"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item
              label="上一年度违章处罚情况"
              prop="forms.lastIllegalPunish"
            >
              <el-input
                v-model="slotForms.forms.lastIllegalPunish"
                placeholder="请输入"
                type="textarea"
                :rows="2"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item
              label="城市冷链配送证类型"
              prop="forms.coldDeliveryCard"
            >
              <dict-select
                :isDisabled="!coldDeliveryCardDisabled"
                v-model="slotForms.forms.coldDeliveryCard"
                placeholder="请选择车辆类型"
                :pkey="'cold_delivery_card_type'"
              ></dict-select>
            </el-form-item>
          </template>
          <template slot="submit">保存</template>
          <template slot="reset">返回</template>
        </e6-form-extend>
      </div>
    </section>
    <!-- content end -->
  </div>
</template>
``
<script>
import { mapGetters } from "vuex";
import { cloneDeep } from "lodash";
import { SaveVehicleInfo, FindVehicleInfoById } from "@/api/base/vehicle";
import resizeListener from "_private/mixins/resizeListener";
import {
  CheckRemarkLength,
  CheckPriceOrDistance,
  CheckPhone,
  CheckVehicleNo,
  validatorIntNum,
  CheckNumberLength
} from "@/utils/validation";
import { FetchGetArea } from "@/api/public";
import { FetchAllCustomer } from "@/api/systemSetting/interfaceUserManager";

import moment from "moment";
export default {
  mixins: [resizeListener],
  data() {
    let that = this;
    var startTimeValidator = (rule, value, callback) => {
      if (that.formExtend.forms.notValidDate && value) {
        if (moment(value).isBefore(that.formExtend.forms.notValidDate)) {
          callback();
        } else {
          callback(new Error("开始时间应小于结束时间"));
        }
      } else {
        callback();
      }
    };
    var endTimeValidator = (rule, value, callback) => {
      if (that.formExtend.forms.validDate && value) {
        if (moment(value).isBefore(that.formExtend.forms.validDate)) {
          callback(new Error("结束时间应大于开始时间"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      breadcrumbs: [
        {
          path: "/home",
          isRedirect: true,
          meta: {
            title: "首页"
          }
        },
        {
          path: "/baseVehicleList",
          isRedirect: true,
          meta: {
            title: "车辆基础信息"
          }
        }
      ],
      startTimeValidator: startTimeValidator,
      endTimeValidator: endTimeValidator,
      formExtend: {
        forms: {
          terUuid: "",
          loadUuid: "",
          vehicleColor: "",
          vehicleNum: "",
          comparyId: "",
          provinceName: "",
          provinceId: "",
          regionName: "",
          oldUuid: "",
          contactMan: "",
          contactPhone: "",
          applyTime: "",
          vehicleType: "",
          refrigerateType: "",
          powerType: "",
          constantTemperatureType: "",
          vehicleBrand: "",

          vehicleLen: "",
          vehicleWide: "",
          vehicleHigh: "",
          outputVolume: "",
          frameNo: "",
          groundHeight: "",
          tonnage: "",
          ratedLoad: "",
          factory: "",
          dbTime: "",
          deTime: "",
          monitorDeviceMerchant: "",
          loadDeviceMerchant: "",
          carriageType: "", // 车厢类型
          temperatureLow: "",
          temperatureHigh: "",
          transType: [],
          coldPassportNo: "",
          importFoodNo: "",
          productionDate: "",
          runMileage: "",
          scrapDate: "",
          lastGetProof: "",
          joinDate: "",
          lastIllegalPunish: "",
          coldDeliveryCard: "",
          validDate: "",
          notValidDate: ""
        },
        extends: []
      },
      editState: false,
      provinceList: [],
      transtypeList: [],
      coldDeliveryCardDisabled: false,
      cityList: [],
      allCustomer: [],
      delivery: "",
      CheckRemarkLength: CheckRemarkLength,
      CheckPriceOrDistance: CheckPriceOrDistance,
      CheckPhone: CheckPhone,
      CheckVehicleNo: CheckVehicleNo,
      validatorIntNum: validatorIntNum,
      CheckNumberLength: CheckNumberLength,
      loadingState: false
    };
  },
  computed: {
    ...mapGetters(["userSourceType"]),
    pageType() {
      return this.$route.query.pageType ? this.$route.query.pageType : "1";
    },
    pageTitle() {
      const pageTitle =
        this.pageType === "1" ? "车辆基础信息新增" : "车辆基础信息修改";
      return pageTitle;
    },
    id() {
      return this.$route.query.id;
    },
    provinceId() {
      return this.$route.query.provinceId;
    }
  },
  created() {
    this.FetchGetArea(0, 1, 1);
    this.initAllCustomer();
    this.getTranstypeList();

    let breadcrumb = {
      path: "/systemSettingDataDictionaryMaintenanceEdit",
      isRedirect: false,
      meta: {
        title: this.pageTitle
      }
    };
    this.breadcrumbs.push(breadcrumb);
    if (this.pageType !== "1") {
      this.FindVehicleInfoById({ vehicleId: this.id });
      this.editState = true;
    } else {
      this.formExtend.forms.joinDate = moment().format("YYYY-MM-DD");
      this.FetchStartAndEndtTime();
    }
  },
  methods: {
    /**
     *  查询运输类型
     */
    getTranstypeList() {
      this.$axios
        .post(
          "/base/dictionary/getDictByDicTypeKey",
          this.$qs.stringify({
            dicTypeKey: "trans_type"
          })
        )
        .then(e => {
          if (e.data.code === 1) {
            this.transtypeList = e.data.result;
            // this.transtypeList.forEach((v) => {
            //   if (v.dicId == 2) {
            //     v.disabled = true;
            //   } else {
            //     v.disabled = false;
            //   }
            // });
            // 企业不展示城市冷链配送车
            if (this.userSourceType != 4) {
              this.transtypeList.forEach(v => {
                if (v.dicId == 2) {
                  v.disabled = true;
                } else {
                  v.disabled = false;
                }
              });
            }
          } else {
            this.errorMessage(e.data.message, e.data.code);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    /**
     * 给开始结束时间赋值   一个月
     */
    FetchStartAndEndtTime() {
      let queryTime = [];
      var currentDate = " 23:59:59";
      var startDate = " 00:00:00";
      queryTime.push(startDate);
      queryTime.push(currentDate);
      this.delivery = queryTime;
    },
    /**
     *  初始化企业下拉信息
     */
    initAllCustomer() {
      FetchAllCustomer()
        .then(response => {
          if (
            response.result &&
            response.result &&
            Array.isArray(response.result)
          ) {
            this.allCustomer = response.result;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    changeTransType() {
      this.coldDeliveryCardDisabled = this.formExtend.forms.transType.includes(
        2
      );
      if (!this.coldDeliveryCardDisabled) {
        this.formExtend.forms.coldDeliveryCard = "";
      }
    },
    // 根据父级获取地区下拉框
    FetchGetArea(parentId, type, num) {
      FetchGetArea(parentId, type)
        .then(response => {
          if (response.result && Array.isArray(response.result)) {
            if (num == 1) {
              this.provinceList = response.result;
            } else if (num == 2) {
              this.cityList = response.result;
            }
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    //省选择事件
    // provinceChange() {
    //   this.provinceList.forEach(item => {
    //     if (this.formExtend.forms.provinceId == item.id) {
    //       this.formExtend.forms.provinceName = item.name;
    //       return;
    //     }
    //   });
    //   this.FetchGetArea(this.formExtend.forms.provinceId, 2, 2);
    //   this.cityList = [];
    //   this.formExtend.forms.regionName = "";
    // },
    // 修改车辆数据时，先获取车辆数据信息
    FindVehicleInfoById(response) {
      FindVehicleInfoById(response)
        .then(response => {
          let res = cloneDeep(response.result);
          this.formExtend.forms = Object.assign({}, res);
          res.validDateStr == "1970-01-01" || res.validDateStr == "1900-01-01"
            ? (this.formExtend.forms.validDate = "")
            : (this.formExtend.forms.validDate = res.validDateStr);
          res.notValidDateStr == "1970-01-01" ||
          res.validDateStr == "1900-01-01"
            ? (this.formExtend.forms.notValidDate = "")
            : (this.formExtend.forms.notValidDate = res.notValidDateStr);
          if (!this.formExtend.forms.joinDate) {
            this.formExtend.forms.joinDate = res.createdTime;
          }
          if (this.formExtend.forms.coldDeliveryCard == 0) {
            this.formExtend.forms.coldDeliveryCard = "";
          }
          if (this.provinceId) {
            this.formExtend.forms.provinceId = this.provinceId;
          } else {
            this.formExtend.forms.provinceId = "";
          }
          // 运输类型处理
          this.coldDeliveryCardDisabled = this.formExtend.forms.transType.includes(
            2
          );
          // 处理温度数据
          if (this.formExtend.forms.temperatureLow == -99) {
            this.formExtend.forms.temperatureLow = "";
          }
          if (this.formExtend.forms.temperatureHigh == -99) {
            this.formExtend.forms.temperatureHigh = "";
          }
          // this.FetchGetArea(this.provinceId, 2, 2);
          const timeList = [];
          if (response.result.dbTime) {
            timeList.push(response.result.dbTime);
          }
          if (response.result.deTime) {
            timeList.push(response.result.deTime);
          }
          this.delivery = timeList;
        })
        .catch(error => {
          console.log(error);
        });
    },

    // 新增，修改车辆数据
    SaveVehicleInfo(response) {
      let params = cloneDeep(response);
      SaveVehicleInfo(params)
        .then(response => {
          this.submitCallback(response);
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 新增车辆信息完成时的回调函数
    submitCallback(response) {
      let type = response.code === 1 ? "success" : "error";
      let message = response.message;
      this.$message({
        showClose: true,
        message: message,
        type: type,
        duration: 2000,
        onClose: () => {
          if (type === "success") {
            this.$router.push({
              path: "/baseVehicleList",
              query: { refreshportion: true }
            });
          }
          this.loadingState = false;
        }
      });
    },
    // 提交
    handleSubmitForm(e) {
      if (e) {
        if (this.delivery) {
          if (this.delivery.length > 0) {
            this.formExtend.forms.dbTime = this.delivery[0];
          }
          if (this.delivery.length > 1) {
            this.formExtend.forms.deTime = this.delivery[1];
          }
        }
        this.loadingState = true;
        this.SaveVehicleInfo(Object.assign({}, this.formExtend.forms));
      }
    },
    // 取消
    handleResetForm() {
      this.$router.push("/baseVehicleList");
    }
  }
};
</script>

<style lang="scss" scoped>
.upload-demo {
  width: 300px;
  margin: 10 150px 10px 200px;
}
.page-view {
  height: 100%;
}
.title-section {
  padding: 15px 20px 10px;
}
.content-section {
  overflow: auto;
}
.content-section {
  .form-wrapper {
    padding-top: 20px;
    margin: 0 20px;
    background-color: #fff;
  }
}
/deep/.hide .el-upload--picture-card {
  display: none;
}
/deep/ .e6-from--column-2 {
  .el-input {
    width: 300px;
  }
  .el-textarea__inner {
    width: 500px;
  }
}
.line {
  width: 95%;
  border: none;
  border-bottom: 1px solid #ddd;
}
.tips {
  color: #999;
  padding-left: 5%;
  margin-bottom: 20px;
}
</style>
